import {createAsyncThunk, createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import IeventType from '../../interfaces/eventtype.Interface';
import IDevice from '../../interfaces/device.Interface';
import Ievent from '../../interfaces/event.Interface';
import IHandle from '../../interfaces/actionhandle.interface';

// Define a type for the slice state
export interface ActionState {
    eventtypes:IeventType[];
    handles:IHandle[];
    devices:IDevice[];
    active_events?:Ievent[];
}

// Define the initial state using that type
const initialState: ActionState = {
    eventtypes: [],
    handles:[],
    devices: [],
    active_events:[]
}

export const fetchEventTypes = createAsyncThunk("eventtypes/getAll", async()=>{
    const response = await fetch(process.env.REACT_APP_API_URI+"/events/eventtypes",{
        method:"GET"
    });
    const data = response.json()
    return data;

});

export const fetchDevices = createAsyncThunk("devices/getByL22", async(L22:string|undefined)=>{
  const response = await fetch(process.env.REACT_APP_API_URI+"/devices/getByL22?L22="+L22,{
      method:"GET",

  });
  const data = response.json()
  return data;

});

export const fetchHandles = createAsyncThunk("events/actions", async()=>{
  const response = await fetch(process.env.REACT_APP_API_URI+"/events/actions",{
      method:"GET",

  });
  const data = response.json()
  return data;

});



export const ActionSlice = createSlice({
  name: 'Actions',
  initialState,
  reducers: {
    setActiveEvents: (state, {payload}:PayloadAction<Ievent[]>)=>{
      state.active_events = payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchEventTypes.fulfilled, (state, {payload}:PayloadAction<IeventType[]>) => {
      state.eventtypes = payload;
    })
    builder.addCase(fetchDevices.fulfilled, (state, {payload}:PayloadAction<IDevice[]>) => {
      state.devices = payload;
    })
    builder.addCase(fetchHandles.fulfilled, (state, {payload}:PayloadAction<IHandle[]>) => {
      state.handles = payload;
    })
    
  }
});
    

export const {setActiveEvents} = ActionSlice.actions


export default ActionSlice.reducer